import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import About from "./pages/About";
import Contact from "./pages/Contact";

const CreatedByBadge = () => (
  <a
    href="https://www.wktechexpert.com/"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-4 right-4 z-50 bg-white shadow-lg px-4 py-2 text-sm text-gray-600 hover:text-brand-red transition-colors border border-gray-200 rounded"
    style={{ fontFamily: 'Outfit, sans-serif' }}
  >
    Created by <span className="font-semibold text-brand-red">wktechexpert.com</span>
  </a>
);

function App() {
  return (
    <div className="App bg-white min-h-screen">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
        <Footer />
        <CreatedByBadge />
      </BrowserRouter>
    </div>
  );
}

export default App;
